import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const NuevaContraseña = () => {
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [error, setError] = useState("");
  const [exito, setExito] = useState(false);
  const navigate = useNavigate();

  const handleCambiar = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmar) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    const email = localStorage.getItem("recoveryEmail");
    if (!email) {
      setError("Correo no encontrado.");
      return;
    }

    try {
      const response = await fetch(
        "https://us-central1-ekineapp.cloudfunctions.net/resetPasswordManual",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, newPassword: password }),
        }
      );

      if (!response.ok) throw new Error("Error en la solicitud");

      setExito(true);
      setTimeout(() => {
        localStorage.removeItem("recoveryEmail");
        navigate("/login");
      }, 2000);

    } catch (err) {
      console.error("❌ Error al cambiar contraseña:", err);
      setError("Ocurrió un error al actualizar la contraseña.");
    }
  };

  return (
    <div
      className="min-h-screen flex justify-center items-center px-4"
      style={{
        background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
      }}
    >
      <div className="w-full max-w-md bg-white/60 backdrop-blur-xl rounded-3xl 
                      shadow-[0_18px_50px_-15px_rgba(58,106,255,0.35)]
                      ring-1 ring-blue-100 p-8">

        <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 text-center mb-6">
          Nueva Contraseña
        </h1>

        {!exito ? (
          <form onSubmit={handleCambiar} className="space-y-5">

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nueva contraseña"
              className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                         focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
              required
            />

            <input
              type="password"
              value={confirmar}
              onChange={(e) => setConfirmar(e.target.value)}
              placeholder="Confirmar contraseña"
              className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                         focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
              required
            />

            <button
              type="submit"
              className="w-full bg-[#3A6AFF] hover:bg-blue-700 text-white py-3 rounded-xl
                         font-semibold transition"
            >
              Guardar nueva contraseña
            </button>
          </form>
        ) : (
          <p className="text-green-600 text-center text-lg font-medium">
            ✅ Contraseña actualizada correctamente.
          </p>
        )}

        {error && (
          <p className="text-red-500 text-sm mt-4 text-center">{error}</p>
        )}
      </div>
    </div>
  );
};

export default NuevaContraseña;
